/** Tiny promise wrapper around IndexedDB for caching user files (jar, world zips) as Blobs. */
const DB = "mc-planner-cache";
const STORE = "files";

function open(): Promise<IDBDatabase> {
  return new Promise((res, rej) => {
    const r = indexedDB.open(DB, 1);
    r.onupgradeneeded = () => r.result.createObjectStore(STORE);
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}

async function tx<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  const db = await open();
  return new Promise((res, rej) => {
    const t = db.transaction(STORE, mode);
    const r = fn(t.objectStore(STORE));
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  });
}

export const idb = {
  get: <T = unknown>(key: string) => tx<T | undefined>("readonly", (s) => s.get(key) as IDBRequest<T | undefined>).catch(() => undefined),
  set: (key: string, value: unknown) => tx("readwrite", (s) => s.put(value, key)).catch((e) => console.warn("idb set failed", e)),
  del: (key: string) => tx("readwrite", (s) => s.delete(key)).catch(() => undefined),
};

export interface CachedFile {
  name: string;
  size: number;
  savedAt: number;
  blob: Blob;
}
